export default __webpack_public_path__ + "static/media/soilmate-logo.083e639a.svg";